import React from "react";
import ReportListShipLost from "./ReportListShipLost";
import { AppConstant } from "const";

const ReportListShipDisconnected = ({ open, onClose }) => {
  return <ReportListShipLost open={open} onClose={onClose} lostType={AppConstant.SHIP_LOST_TYPE.disconnected} />;
};

export default ReportListShipDisconnected;
